import { useState } from 'react';
import { Box, Chip, Collapse, Divider, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { AgentBranchChips, AgentEmail } from './AgentManagerChips';
import { agentLabel } from './agentManagerUtils';

const AgentRowActions = ({ row, onEdit, onRemove }) => (
  <Box display="flex" flexShrink={0}>
    <Tooltip title="עריכה">
      <IconButton size="small" onClick={() => onEdit(row)}>
        <EditOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title="הסרה">
      <IconButton size="small" color="error" onClick={() => onRemove(row)}>
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Box>
);

const AgentRow = ({ row, isFirst, agentEmails, branchNames, canEdit, onEdit, onRemove }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={1}
    py={1}
    borderTop={isFirst ? 'none' : '1px solid #f0f0f0'}
  >
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      <Box display="flex" flexDirection="column" minWidth={200}>
        <Typography variant="body2" fontWeight={500}>
          {agentLabel(row)}
        </Typography>
        {agentEmails && <AgentEmail email={agentEmails.get(row.agentCode)} />}
      </Box>
      <AgentBranchChips branches={row.branches} branchNames={branchNames} />
    </Box>
    {canEdit && <AgentRowActions row={row} onEdit={onEdit} onRemove={onRemove} />}
  </Box>
);

const ManagerCardHeader = ({ manager, expanded, onToggle }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    px={2}
    py={1.5}
    sx={{ cursor: 'pointer', '&:hover': { bgcolor: '#f5f8ff' } }}
    onClick={onToggle}
  >
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      <Typography fontWeight={600} color="#1f2937">
        {manager.name}
      </Typography>
      <Chip label={`${manager.rows.length} סוכנים`} size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
      <Typography variant="caption" color="text.secondary" dir="ltr">
        {manager.email}
      </Typography>
    </Box>
    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </Box>
);

// One manager: their agents, each with its branches (collapsed by default).
const ManagerCard = ({ manager, ...rowProps }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Paper variant="outlined" sx={{ mb: 1.5, borderRadius: 2, overflow: 'hidden' }}>
      <ManagerCardHeader manager={manager} expanded={expanded} onToggle={() => setExpanded((p) => !p)} />
      <Collapse in={expanded}>
        <Divider />
        <Box px={2} py={1}>
          {manager.rows.map((row, i) => (
            <AgentRow key={row._id} row={row} isFirst={i === 0} {...rowProps} />
          ))}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default ManagerCard;
